module.exports = __webpack_public_path__ + "static/media/iris_cropped.75a3fcd0.png";